<template>
    <div class="plan-badge" :class="{ 'plan-badge--warn': isExpiringSoon }">
        <div class="plan-info">
            <span class="plan-name">{{ planTitle }}</span>
            <template v-if="hasCountdown">
                <span class="plan-divider">·</span>
                <span class="plan-days">{{ countdownLabel }}</span>
            </template>
        </div>
        <button type="button" class="plan-action" @click="$emit('upgrade')">
            {{ isExpiringSoon ? 'ПРОДЛИТЬ' : 'ОБНОВИТЬ' }}
        </button>
        <div v-if="isExpiringSoon" class="plan-reminder">Скоро закончится — продлите тариф</div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    plan: { type: String, default: 'free' },
    planName: { type: String, default: '' },
    daysLeft: { type: Number, default: null },
    isTrial: { type: Boolean, default: false },
})

defineEmits(['upgrade'])

// Показываем человекочитаемое название тарифа; на код (FREE/PRO…) откатываемся
// только если имя ещё не подгрузилось.
const planTitle = computed(() => props.planName || (props.plan || '').toUpperCase())

// Счётчик показываем только если известен остаток дней (есть срок действия).
const hasCountdown = computed(() => props.daysLeft !== null && props.daysLeft !== undefined)

const isExpiringSoon = computed(() => hasCountdown.value && props.daysLeft <= 3)

function dayWord(n) {
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) return 'день'
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 'дня'
    return 'дней'
}

const countdownLabel = computed(() => {
    if (!hasCountdown.value) return ''
    const n = props.daysLeft
    if (n <= 0) return 'Истёк'
    return `${n} ${dayWord(n)}`
})
</script>

<style scoped>
.plan-badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px 10px 10px;
    border-top: 1px solid #e0e0e0;
    gap: 8px;
}

.plan-info {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #23282C;
    font-weight: 600;
}

.plan-divider {
    color: #c0c0c0;
}

.plan-days {
    font-variant-numeric: tabular-nums;
    color: #198FA0;
}

.plan-badge--warn .plan-days {
    color: #C0050F;
}

.plan-action {
    background: transparent;
    border: 0;
    color: #E30613;
    font-family: inherit;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.4px;
    cursor: pointer;
}

.plan-action:hover {
    text-decoration: underline;
}

.plan-reminder {
    flex-basis: 100%;
    font-size: 10.5px;
    color: #C0050F;
    line-height: 1.3;
}
</style>
